export const addDaysToDate = (days: number): string => {
  const now = new Date()
  const msToAdd = days * 24 * 60 * 60 * 1000 // переводим дни (включая дробные) в миллисекунды
  const futureDate = new Date(now.getTime() + msToAdd)

  return futureDate.toISOString().split('.')[0] + 'Z'
}
